import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { IndustrySelect } from "@/components/JobSelect/industrySelect";
import { NewJobSelect } from "@/components/JobSelect/jobSelect";
import useAppStore from "@/context/store";
import { setSettings } from "@/services";
import { useMemoizedFn } from "ahooks";
import { Button, Form } from "antd";
import classNames from "classnames";
import { useState } from "react";
import AreaSelect from "./AreaSelect";
import styles from "./index.module.less";
/**
 *
 * @param {import("antd").ModalProps} param
 * @returns
 */
function DialogRaw({ onOk, ...props }) {
  const [submitState, setSubmitState] = useState(true);
  const onFormChange = useMemoizedFn((values, all) => {
    if (all.market_job_tag_id && all.areas) {
      setSubmitState(false);
    } else {
      setSubmitState(true);
    }
  });

  const onFinish = useMemoizedFn(async (values) => {
    const res = await setSettings({
      // 职业
      market_job_tag_id: values.market_job_tag_id,
      market_industry_tag_ids: values.market_industry_tag_ids,
      // 领域
      job_ids: values.areas,
    });

    if (!res.err) {
      HBMessage.success("设置成功");
      useAppStore.getState().refreshUser();
      onOk();
    }
  });

  const [industrySelectCount, setindustrySelectCount] = useState(0);

  return (
    <HBModal
      {...props}
      footer={null}
      width={740}
      wrapClassName={styles.dialog}
      maskClosable={false}
      closeIcon={
        <HBIcon
          type="ic_close"
          data-gd-click="button_click"
          data-button-name="关闭新人引导弹框"
          data-content-source="新人引导弹框"
        />
      }
    >
      <div className={styles.header}>
        <div className={styles.title}>欢迎来到花瓣</div>
        <div className={styles.subTitle}>
          让我们更加了解你，帮助我们找到适合你的内容
        </div>
      </div>
      <Form layout="vertical" onValuesChange={onFormChange} onFinish={onFinish}>
        <Form.Item
          className={classNames([styles.item, styles.last])}
          name="market_job_tag_id"
          label="你所从事的职业"
          required
        >
          <NewJobSelect placeholder="请选择你的职业" />
        </Form.Item>
        <div style={{ position: "relative" }}>
          <div className={styles.formItemRight}>
            可多选{industrySelectCount}/3
          </div>

          <Form.Item
            label="你所在的行业（该信息不会对外展示）"
            name="market_industry_tag_ids"
          >
            {/* <JobSelect selectCol={24} inputCol={24} noWrapper={true} /> */}
            <IndustrySelect
              placeholder="请选择你的行业"
              onChange={(value) => {
                setindustrySelectCount(value?.length || 0);
              }}
            />
          </Form.Item>
        </div>

        <Form.Item
          required
          label="你感兴趣的领域（可多选）"
          className={classNames([styles.item, styles.last])}
          name="areas"
        >
          <AreaSelect></AreaSelect>
        </Form.Item>

        <Form.Item className={styles.submit}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitState}
            data-gd-click="button_click"
            data-button-name="我选好了"
            data-content-source="新人引导弹框"
          >
            我选好了
          </Button>
        </Form.Item>
      </Form>
    </HBModal>
  );
}

const GuideDialog = ModalWrap(DialogRaw, { unique: true });

export default GuideDialog;
